/**
  Copyright (c) 2015, 2019, Oracle and/or its affiliates.
  The Universal Permissive License (UPL), Version 1.0
*/
'use strict';
/**
 * Example of Require.js boostrap javascript
 */

var GLOBAL_NAV,
    GLOBAL_ROUTER,
    GLOBAL_KO,
    GLOBAL_UTILS = {},
    GLOBAL_isPOSenabled;
requirejs.config(GLOBAL_CONFIG.require);
/* eslint-disable quote-props */

requirejs.config({
  baseUrl: 'js',
  // Path mappings for the logical module names
  // Update the main-release-paths.json for release mode when updating the mappings
  paths: //injector:mainReleasePaths
  {
    "knockout": "libs/knockout/knockout-3.5.1.debug",
    "jquery": "libs/jquery/jquery-3.5.1",
    "jqueryui-amd": "libs/jquery/jqueryui-amd-1.12.1",
    "promise": "libs/es6-promise/es6-promise",
    "hammerjs": "libs/hammer/hammer-2.0.8",
    "ojdnd": "libs/dnd-polyfill/dnd-polyfill-1.0.0",
    "persist": "libs/persist/debug",
    "ojs": "libs/oj/v6.2.0/debug",
    "ojL10n": "libs/oj/v6.2.0/ojL10n",
    "ojtranslations": "libs/oj/v6.2.0/resources",
    "text": "libs/require/text",
    "signals": "libs/js-signals/signals",
    "touchr": "libs/touchr/touchr",
    "customElements": "libs/webcomponents/custom-elements.min",
    "css": "libs/require-css/css",
    "utils": "framework/utils",
    "helpers": "framework/utils/helpers",
    "knockout-amd-helpers": "framework/utils/ext/knockout/knockout-amd-helpers.min",
    "simple-keyboard": "libs/simple-keyboard/src/index",
    "oms-virtual-keyboard": "jet-composites/oms-virtual-keyboard/1.0.0"
  } //endinjector
  ,
  // Shim configurations for modules that do not expose AMD
  shim: {
    'jquery': {
      exports: ['jQuery', '$']
    }
  },
  config: {
    ojL10n: {
      merge: {}
    }
  }
});

require(['ojs/ojcore', 'knockout', 'jquery', 'appController', 'application/global/labels', 'ojs/ojknockout', 'knockout-amd-helpers'], function (oj, ko, $, app, lang) {
  GLOBAL_UTILS.msg = null;
  GLOBAL_UTILS.mdQuery = {};
  [1024, 1280, 1600].forEach(function (v) {
    GLOBAL_UTILS.mdQuery["MIN_".concat(v)] = oj.ResponsiveKnockoutUtils.createMediaQueryObservable("(min-width: ".concat(v, "px)"));
    GLOBAL_UTILS.mdQuery["MAX_".concat(v)] = oj.ResponsiveKnockoutUtils.createMediaQueryObservable("(max-width: ".concat(v, "px)"));
  });
  var smQuery = oj.ResponsiveUtils.getFrameworkQuery(oj.ResponsiveUtils.FRAMEWORK_QUERY_KEY.SM_ONLY);
  GLOBAL_UTILS.smScreen = oj.ResponsiveKnockoutUtils.createMediaQueryObservable(smQuery);
  var mdQuery = oj.ResponsiveUtils.getFrameworkQuery(oj.ResponsiveUtils.FRAMEWORK_QUERY_KEY.MD_UP);
  GLOBAL_UTILS.mdScreen = oj.ResponsiveKnockoutUtils.createMediaQueryObservable(mdQuery);
  GLOBAL_UTILS.lang = lang;
  GLOBAL_isPOSenabled = ko.observable(false);
  $(function () {
    function init() {
      oj.Router.sync().then(function () {
        var promise = new Promise(function (resolve, reject) {
          resolve();
        }).then(function () {
          // Bind your ViewModel for the content of the whole page body.
          app.loadModule();
          ko.applyBindings(app, document.getElementById('globalBody'));
        });
      }, function (error) {
        oj.Logger.error('Error in root start: ' + error.message);
      });
    }

    function init1() {
      oj.Router.sync().then(function () {
        oj.Logger.error('sync called'); // Bind your ViewModel for the content of the whole page body.

        app.loadModule();
        ko.applyBindings(app, document.getElementById('globalBody'));
      }, function (error) {
        oj.Logger.error('sync error');
        oj.Logger.error('Error in root start: ' + error.message);
      });
    } // If running in a hybrid (e.g. Cordova) environment, we need to wait for the deviceready
    // event before executing any code that might interact with Cordova APIs or plugins.


    if ($(document.body).hasClass('oj-hybrid')) {
      document.addEventListener('deviceready', init);
    } else {
      init();
    }
  });
});
define("main", function(){});

